import { useQuery } from '@tanstack/react-query';

import fetchTravelersUsingLot from '../api/fetchTravelersUsingLot';

export default function useTravelersUsingLot(lotId) {
  return useQuery({
    queryKey: ['travelersUsingLot', lotId],
    queryFn: () => fetchTravelersUsingLot(lotId),
    enabled: !!lotId,
  });
}
